var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-layout',{staticClass:"layout-default",class:[_vm.layoutClass],attrs:{"id":"layout-default"}},[_c('a-layout-content',[_c('router-view')],1),_c('DefaultFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }